import React, { useEffect, useState } from 'react';
import ImageWithBaseApi from '../../../../core/img/ImageWithBaseApi';
import { ComplaintModalProps } from '../../../../core/Interface/modalInterface';
import { Complaint } from '../../../../core/Interface/repositoryInterfaces';
import * as Icon from 'react-feather';

const ComplaintModal: React.FC<ComplaintModalProps> = ({ selectedComplaint }) => {
  const [complaintData, setComplaintData] = useState<Complaint>();

  useEffect(() => {
    setComplaintData(selectedComplaint);
  }, [selectedComplaint]);

  return (
    <div className="modal fade" id="complaint-modal">
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content shadow-lg rounded-lg">
          <div className="modal-header text-white">
            <h5 className="modal-title">
              Detalles de la Queja
            </h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Cerrar"></button>
          </div>
          <div className="modal-body mt-0 pt-0">
            <div className="container">
              {/* Sección de Información Personal */}
              <div className="section mb-4 mt-0 pt-0">
                <div className="section-header d-flex align-items-center border-bottom pb-2 mb-3">
                  <Icon.User size={20} className="text-primary me-2" />
                  <h5 className="mb-0"><strong>Información Personal</strong></h5>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="info-item mb-2">
                      <div className="d-flex align-items-center">
                        <Icon.User size={16} className="text-secondary me-2" />
                        <strong>Nombre Completo:</strong>
                      </div>
                      <div className="ps-4 mt-1">{complaintData?.fullName}</div>
                    </div>
                    <div className="info-item mb-2">
                      <div className="d-flex align-items-center">
                        <Icon.CreditCard size={16} className="text-secondary me-2" />
                        <strong>DNI/CE:</strong>
                      </div>
                      <div className="ps-4 mt-1">{complaintData?.dniOrCe}</div>
                    </div>
                    <div className="info-item mb-2">
                      <div className="d-flex align-items-center">
                        <Icon.Phone size={16} className="text-secondary me-2" />
                        <strong>Contacto:</strong>
                      </div>
                      <div className="ps-4 mt-1">{complaintData?.phoneOrEmail}</div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    {complaintData?.tutorFullName && (
                      <div className="info-item mb-2">
                        <div className="d-flex align-items-center">
                          <Icon.Users size={16} className="text-secondary me-2" />
                          <strong>Nombre del Tutor:</strong>
                        </div>
                        <div className="ps-4 mt-1">{complaintData?.tutorFullName}</div>
                      </div>
                    )}
                    <div className="info-item mb-2">
                      <div className="d-flex align-items-center">
                        <Icon.MapPin size={16} className="text-secondary me-2" />
                        <strong>Dirección:</strong>
                      </div>
                      <div className="ps-4 mt-1">{complaintData?.address}</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Sección de Detalles de la Queja */}
              <div className="section mb-4 mt-0 pt-0">
                <div className="section-header d-flex align-items-center border-bottom pb-2 mb-3">
                  <Icon.AlertTriangle size={20} className="text-warning me-2" />
                  <h5 className="mb-0"><strong>Detalles de la Queja o Reclamo</strong></h5>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="info-item mb-2">
                      <div className="d-flex align-items-center">
                        <Icon.Tag size={16} className="text-secondary me-2" />
                        <strong>Tipo:</strong>
                      </div>
                      <div className="ps-4 mt-1">
                        <span className={`badge ${complaintData?.complaintOrClaim === 'Queja' ? 'bg-warning' : 'bg-danger'}`}>
                          {complaintData?.complaintOrClaim}
                        </span>
                      </div>
                    </div>
                    <div className="info-item mb-2">
                      <div className="d-flex align-items-center">
                        <Icon.Hash size={16} className="text-secondary me-2" />
                        <strong>Número de Orden:</strong>
                      </div>
                      <div className="ps-4 mt-1">{complaintData?.order}</div>
                    </div>
                    <div className="info-item mb-2">
                      <div className="d-flex align-items-center">
                        <Icon.ShoppingBag size={16} className="text-secondary me-2" />
                        <strong>Producto o Servicio:</strong>
                      </div>
                      <div className="ps-4 mt-1">{complaintData?.productOrService}</div>
                    </div>
                    <div className="info-item mb-2">
                      <div className="d-flex align-items-center">
                        <Icon.DollarSign size={16} className="text-secondary me-2" />
                        <strong>Monto Total:</strong>
                      </div>
                      <div className="ps-4 mt-1">{complaintData?.totalAmount}</div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="info-item mb-2">
                      <div className="d-flex align-items-center">
                        <Icon.FileText size={16} className="text-secondary me-2" />
                        <strong>Descripción:</strong>
                      </div>
                      <div className="ps-4 mt-1">{complaintData?.description}</div>
                    </div>
                    <div className="info-item mb-2">
                      <div className="d-flex align-items-center">
                        <Icon.Info size={16} className="text-secondary me-2" />
                        <strong>Detalle:</strong>
                      </div>
                      <div className="ps-4 mt-1">{complaintData?.detail}</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Sección de Evidencia */}
              {complaintData?.evidence && (
                <div className="section">
                  <div className="section-header d-flex align-items-center border-bottom pb-2 mb-3">
                    <Icon.Image size={20} className="text-info me-2" />
                    <h5 className="mb-0"><strong>Evidencia</strong></h5>
                  </div>
                  <div className="text-center p-3 bg-light rounded">
                    <div className="profile-upload-img">
                      <ImageWithBaseApi
                        src={complaintData?.evidence}
                        routeName="complaint"
                        className="img-fluid shadow rounded"
                        style={{ maxHeight: '300px', width: 'auto', objectFit: 'contain' }}
                        alt="Evidencia del reclamo"
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
              <Icon.X size={16} className="me-1" />
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComplaintModal;